import request from "@/router/axios";

// 客户返佣
export const loanPaymentRecordPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-loanPaymentRecord/loanPaymentRecord/page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

// 详情
export const loanPaymentRecordDetails = (loanPaymentRecordId) => {
  return request({
    url: `/api/blade-loanPaymentRecord/loanPaymentRecord/details`,
    method: "post",
    data: {
      loanPaymentRecordId,
    },
  });
};
// 多个详情
export const loanPaymentRecordMoreDetails = (loanPaymentRecordId) => {
  return request({
    url: `/api/blade-loanPaymentRecord/loanPaymentRecord/more_details`,
    method: "post",
    data: {
      loanPaymentRecordId
    },
  });
};

//  提交
export const loanPaymentRecordSumbit = (data) => {
  return request({
    url: `/api/blade-loanPaymentRecord/loanPaymentRecord/submit`,
    method: "post",
    data: data
  });
};

